import FlashOfferDeal from '@/onenetwork/components/datatable/FlashOfferDeal.vue'
import FlashOfferListingCell from '@/onenetwork/components/datatable/FlashOfferListingCell.vue'
import FlashOfferStatistic from '@/onenetwork/components/datatable/FlashOfferStatistic.vue'
import TextCell from '@/onenetwork/components/datatable/TextCell.vue'
import { APIClient } from '@/onenetwork/core/onenetwork.api.instant.ts'
import { defineStore } from 'pinia'
import { markRaw } from 'vue'
import { uuid } from 'vue3-uuid'
import { FlashOfferAPI } from '../constants/flashoffer.api.uri.const'
import { getRegionFitter } from '../helper/form'
import { formatTableDataFlashOfferDetail, formatTableDataFlashOfferResult } from '../helper/table'


export interface tabItem {
  id: string,
  label: string,
  active: boolean,
}

export enum FlashOfferDetailActionTypes {
  FILTERING = 'FILTERING',
  PENDING= "PENDING",
  FETCHING= "FETCHING",
  FETCH_SUCCESS = "FETCH_SUCCESS",
  FETCH_FAILURE = "FETCH_FAILURE",
}

interface FlashOfferDetailStore {
  action_type: FlashOfferDetailActionTypes,
  action_mess: string,
  uuid: string,
  detail: Object,
  data: Object,
  filter: Array<{
    key: string,
    type: string,
    label: string,
    placeholder: string,
    value: any,
    options?: Array<{label: string, value: string}>
  }>,
  pageSize: number,
  page: number,
  tabs: Array<any>,
  tableConfig: any,
  selectedIds: Array<string|number>,
}

export const useFlashOfferDetailStore = defineStore('flash_offer.detail', {
  state: (): FlashOfferDetailStore => ({
    action_type: FlashOfferDetailActionTypes.PENDING,
    action_mess: "",
    uuid: '',
    detail: {},
    data: {
      list: [],
      totalRecords: 0,
      totalPage: 0,
    },
    filter: [
      {
        key: 'province_id',
        type: 'region-level-1',
        label: 'Lọc theo tỉnh/thành',
        placeholder: 'Chọn tỉnh / thành',
        value: [],
        options: null,
      },
      {
        key: 'ward_id',
        type: 'region-level-2',
        label: 'Lọc theo phường / xã',
        placeholder: 'Chọn phường xã',
        value: '',
        options: null,
      },
      {
        key: 'title',
        type: 'taginput',
        label: 'Lọc theo tiêu đề',
        placeholder: 'Nhập tiêu đề',
        value: '',
      },
    ],
    pageSize: 10,
    page: 1,
    tabs: [
      {
        id: 'list',
        label: 'Chi tiết FlashOffer',
        active: true,
      }
    ],
    tableConfig: {
      canShowHide: true,
      columns: {
        id: { label: 'ID', component: markRaw(TextCell), class: '', visible: true, sort: false, config: {} },
        subject: { label: 'Sản phẩm mở bán', component: markRaw(FlashOfferListingCell), class: '', visible: true, sort: false, config: {} },
        statistic: { label: 'Thống kê', component: markRaw(FlashOfferStatistic), class: 'w-[300px]', visible: true, sort: false, config: {} },
        deal: { label: 'Trạng thái GD', component: markRaw(FlashOfferDeal), class: '', visible: true, sort: false, config: {} },
      }
    },
    selectedIds: []
  }),
  getters: {
    sortFilter: state => {
      const sort: any = []
      if(Object.keys(state.tableConfig?.columns).length>0){
        Object.keys(state.tableConfig?.columns).forEach(col => {
          if(state.tableConfig.columns[col].sort) {
            sort.push([col, state.tableConfig.columns[col].sort])
          }
        })
      }
      return sort
    }
  },
  actions: {
    //TAB ACTION
    changeTab (targetId: string) {

      for (const tab of this.tabs) {
        tab.active = (tab.id === targetId)
      }
    },
    closeTab (targetId: string) {
      const index = this.tabs.findIndex(tab => tab.id === targetId)
      if (index !== -1) {
        this.tabs.splice(index, 1)
      }
    },
    closeAllTab () {
      this.tabs = [{
        id: 'list',
        label: 'Chi tiết FlashOffer',
        active: true,
      }]
    },
    newTab (item: tabItem) {
      const exists = this.tabs.some(tab => tab.id === item.id)
      if (!exists) {
        this.tabs.push(item)
      }
      this.changeTab(item.id)
    },

    //FILTER ACTION
    setFilter (filter: any) {
      this.filter = filter
      this.action_type = FlashOfferDetailActionTypes.FILTERING
      this.uuid = uuid.v4()
    },
    changeFilter (key: string, value: any) {
      const filterItem = this.filter.find((item: {key: string}) => item.key === key)
      if (filterItem) {
        filterItem.value = value
        this.action_type = FlashOfferDetailActionTypes.FILTERING
        this.uuid = uuid.v4()
      }
    },
    putFilter(key: string, value: any) {
      this.filter = this.filter.map((field) => {

        if (field.key === key) {
          return { ...field, value: value }
        }
        return field
      })
    },

    //PAGE ACTION
    changePage (page: number) {
      this.page = page
      this.action_type = FlashOfferDetailActionTypes.FILTERING
      this.uuid = uuid.v4()
    },
    changePageSize (size: number) {
      this.pageSize = size
      this.action_type = FlashOfferDetailActionTypes.FILTERING
      this.uuid = uuid.v4()
    },

    //TABLE CONFIG ACTION
    toggleColumnVisibility(columnCode: string, visible: boolean) {
      if (this.tableConfig?.columns[columnCode]) {
        this.tableConfig.columns[columnCode].visible = visible
      } else {
        console.warn(`Column "${columnCode}" không tồn tại trong tableConfig`)
      }
    },
    toggleSort(columnCode: string, sort: string) {
      if (this.tableConfig?.columns[columnCode]) {
        this.tableConfig.columns[columnCode].sort = sort
      } else {
        console.warn(`Column "${columnCode}" không tồn tại trong tableConfig`)
      }
    },

    //FETCH DATA
    async fetchDetail(id: string){
      const res = await APIClient.get(FlashOfferAPI.flashoffer.detail.replace(':id', id))
      const { data } = res.data;

      this.detail = formatTableDataFlashOfferDetail(data);
      if (res.data.code === 200) {
        //put filter
        const [region, district] = getRegionFitter(data.items[0].province_id, data.items[0].district_id);
        this.putFilter('province_id', [{id: region?.id, name: region?.name, select: true}])
        this.putFilter('district_id', [{id: district?.id, name: district?.name, select: true}])

        this.fetchDetailItems(id)
      }
    },
    //DATA ACTION
    async fetchDetailItems(id: string){
      return new Promise( async (resolve, reject) => {
        try{
          this.action_type = FlashOfferDetailActionTypes.FETCHING
          const sort = this.sortFilter
          const filter = {
            page: this.page,
            pageSize: this.pageSize,
            sort,
            flash_offer_id: id
          }

          const res = await APIClient.get(FlashOfferAPI.flashoffer.flash_offer_item, {
            params: filter
          })
          const { data } = res.data
          this.data = {
            list: formatTableDataFlashOfferResult(data?.data),
            totalRecords: data.total,
            totalPage: data.total_page
          }
          this.action_type = FlashOfferDetailActionTypes.FETCH_SUCCESS
          resolve(res)
        } catch (e) {
          this.action_type = FlashOfferDetailActionTypes.FETCH_FAILURE
          reject(e)
        }
      })
    }
  }
})
